import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { finalize } from 'rxjs';
import { BillingService } from 'app/services/billing/billing.service';
import { Invoice } from 'app/services/billing/billing.type';

type PaymentMethod = 'boleto' | 'pix' | null;

@Component({
    selector: 'pay-invoice-modal',
    templateUrl: './pay-invoice-modal.component.html',
    styleUrls: ['./pay-invoice-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule
    ]
})
export class PayInvoiceModalComponent implements OnInit {
    selectedMethod: PaymentMethod = null;
    loading: boolean = false;

    // Dados do pagamento gerado
    paymentData: {
        boleto?: {
            barcode: string;
            pdf_url: string;
            expires_at: string;
        };
        pix?: {
            qr_code: string;
            qr_code_url: string;
            expires_at: string;
        };
    } | null = null;

    constructor(
        public dialogRef: MatDialogRef<PayInvoiceModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { invoice: Invoice },
        private _billingService: BillingService
    ) {}

    ngOnInit(): void {}

    selectMethod(method: PaymentMethod): void {
        if (!this.loading && !this.paymentData) {
            this.selectedMethod = method;
        }
    }

    processPayment(): void {
        if (!this.selectedMethod || this.loading) {
            return;
        }

        this.loading = true;

        this._billingService.payInvoice(this.data.invoice.id, this.selectedMethod)
            .pipe(finalize(() => this.loading = false))
            .subscribe({
                next: (response) => {
                    this.paymentData = response.data;
                },
                error: () => {}
            });
    }

    copyToClipboard(text: string): void {
        navigator.clipboard.writeText(text);
    }

    formatCurrency(value: number): string {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value / 100);
    }

    getStatusLabel(status: string): string {
        const statusMap: Record<string, string> = {
            'pending': 'Pendente',
            'paid': 'Pago',
            'failed': 'Falhou',
            'void': 'Cancelado'
        };
        return statusMap[status] || status;
    }

    getPaymentProgress(): number {
        const status = this.data.invoice.status;
        if (status === 'paid') return 100;
        if (status === 'failed' || status === 'void') return 0;
        return 30;
    }

    closeModal(): void {
        this.dialogRef.close({ action: this.paymentData ? 'payment_generated' : 'cancelled' });
    }
}
